var exports = {
  "UT": "MenuItems.module__roleIcon___MTNZLV",
  "yk": "MenuItems.module__roleContainer___MTNZLV",
  "S3": "MenuItems.module__roleName___MTNZLV",
  "nT": "MenuItems.module__roleDisabled___MTNZLV",
  "u8": "MenuItems.module__readonlyRoleItem___MTNZLV",
  "zQ": "MenuItems.module__readonlyRoleSpacer___MTNZLV",
  "ec": "MenuItems.module__flexColumn___MTNZLV",
  "Kk": "MenuItems.module__icon___MTNZLV",
  "Bx": "MenuItems.module__iconSmall___MTNZLV",
};

module.exports = exports;
